/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminPlayerTrainingAttendance } from './AdminPlayerTrainingAttendance';
import {
    AdminPlayerTrainingAttendanceFromJSON,
    AdminPlayerTrainingAttendanceFromJSONTyped,
    AdminPlayerTrainingAttendanceToJSON,
    AdminPlayerTrainingAttendanceToJSONTyped,
} from './AdminPlayerTrainingAttendance';
import type { AdminPlayerParticipationEvent } from './AdminPlayerParticipationEvent';
import {
    AdminPlayerParticipationEventFromJSON,
    AdminPlayerParticipationEventFromJSONTyped,
    AdminPlayerParticipationEventToJSON,
    AdminPlayerParticipationEventToJSONTyped,
} from './AdminPlayerParticipationEvent';
import type { AdminPlayerOfficialMatch } from './AdminPlayerOfficialMatch';
import {
    AdminPlayerOfficialMatchFromJSON,
    AdminPlayerOfficialMatchFromJSONTyped,
    AdminPlayerOfficialMatchToJSON,
    AdminPlayerOfficialMatchToJSONTyped,
} from './AdminPlayerOfficialMatch';

/**
 * 
 * @export
 * @interface AdminPlayerDetail
 */
export interface AdminPlayerDetail {
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerDetail
     */
    playerId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerDetail
     */
    personId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerDetail
     */
    playerName: string;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerDetail
     */
    birthYear?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerDetail
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminPlayerDetail
     */
    sportCode: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminPlayerDetail
     */
    activeTeamNames: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerDetail
     */
    officialMatchesPlayed: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerDetail
     */
    participationHistoryMatchesPlayed: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerDetail
     */
    totalMatchesPlayed: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerDetail
     */
    attendedTrainingSessions: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerDetail
     */
    totalTrainingSessions: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPlayerDetail
     */
    trainingAttendanceRate: number;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerDetail
     */
    lastPlayedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof AdminPlayerDetail
     */
    lastTrainingAttendanceAt?: Date | null;
    /**
     * 
     * @type {Array<AdminPlayerOfficialMatch>}
     * @memberof AdminPlayerDetail
     */
    matches: Array<AdminPlayerOfficialMatch>;
    /**
     * 
     * @type {Array<AdminPlayerParticipationEvent>}
     * @memberof AdminPlayerDetail
     */
    events: Array<AdminPlayerParticipationEvent>;
    /**
     * 
     * @type {Array<AdminPlayerTrainingAttendance>}
     * @memberof AdminPlayerDetail
     */
    trainings: Array<AdminPlayerTrainingAttendance>;
}

/**
 * Check if a given object implements the AdminPlayerDetail interface.
 */
export function instanceOfAdminPlayerDetail(value: object): value is AdminPlayerDetail {
    if (!('playerId' in value) || value['playerId'] === undefined) return false;
    if (!('personId' in value) || value['personId'] === undefined) return false;
    if (!('playerName' in value) || value['playerName'] === undefined) return false;
    if (!('sportCode' in value) || value['sportCode'] === undefined) return false;
    if (!('activeTeamNames' in value) || value['activeTeamNames'] === undefined) return false;
    if (!('officialMatchesPlayed' in value) || value['officialMatchesPlayed'] === undefined) return false;
    if (!('participationHistoryMatchesPlayed' in value) || value['participationHistoryMatchesPlayed'] === undefined) return false;
    if (!('totalMatchesPlayed' in value) || value['totalMatchesPlayed'] === undefined) return false;
    if (!('attendedTrainingSessions' in value) || value['attendedTrainingSessions'] === undefined) return false;
    if (!('totalTrainingSessions' in value) || value['totalTrainingSessions'] === undefined) return false;
    if (!('trainingAttendanceRate' in value) || value['trainingAttendanceRate'] === undefined) return false;
    if (!('matches' in value) || value['matches'] === undefined) return false;
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('trainings' in value) || value['trainings'] === undefined) return false;
    return true;
}

export function AdminPlayerDetailFromJSON(json: any): AdminPlayerDetail {
    return AdminPlayerDetailFromJSONTyped(json, false);
}

export function AdminPlayerDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminPlayerDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'playerId': json['playerId'],
        'personId': json['personId'],
        'playerName': json['playerName'],
        'birthYear': json['birthYear'] == null ? undefined : json['birthYear'],
        'email': json['email'] == null ? undefined : json['email'],
        'sportCode': json['sportCode'],
        'activeTeamNames': json['activeTeamNames'],
        'officialMatchesPlayed': json['officialMatchesPlayed'],
        'participationHistoryMatchesPlayed': json['participationHistoryMatchesPlayed'],
        'totalMatchesPlayed': json['totalMatchesPlayed'],
        'attendedTrainingSessions': json['attendedTrainingSessions'],
        'totalTrainingSessions': json['totalTrainingSessions'],
        'trainingAttendanceRate': json['trainingAttendanceRate'],
        'lastPlayedAt': json['lastPlayedAt'] == null ? undefined : (new Date(json['lastPlayedAt'])),
        'lastTrainingAttendanceAt': json['lastTrainingAttendanceAt'] == null ? undefined : (new Date(json['lastTrainingAttendanceAt'])),
        'matches': ((json['matches'] as Array<any>).map(AdminPlayerOfficialMatchFromJSON)),
        'events': ((json['events'] as Array<any>).map(AdminPlayerParticipationEventFromJSON)),
        'trainings': ((json['trainings'] as Array<any>).map(AdminPlayerTrainingAttendanceFromJSON)),
    };
}

export function AdminPlayerDetailToJSON(json: any): AdminPlayerDetail {
    return AdminPlayerDetailToJSONTyped(json, false);
}

export function AdminPlayerDetailToJSONTyped(value?: AdminPlayerDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'playerId': value['playerId'],
        'personId': value['personId'],
        'playerName': value['playerName'],
        'birthYear': value['birthYear'],
        'email': value['email'],
        'sportCode': value['sportCode'],
        'activeTeamNames': value['activeTeamNames'],
        'officialMatchesPlayed': value['officialMatchesPlayed'],
        'participationHistoryMatchesPlayed': value['participationHistoryMatchesPlayed'],
        'totalMatchesPlayed': value['totalMatchesPlayed'],
        'attendedTrainingSessions': value['attendedTrainingSessions'],
        'totalTrainingSessions': value['totalTrainingSessions'],
        'trainingAttendanceRate': value['trainingAttendanceRate'],
        'lastPlayedAt': value['lastPlayedAt'] == null ? value['lastPlayedAt'] : value['lastPlayedAt'].toISOString(),
        'lastTrainingAttendanceAt': value['lastTrainingAttendanceAt'] == null ? value['lastTrainingAttendanceAt'] : value['lastTrainingAttendanceAt'].toISOString(),
        'matches': ((value['matches'] as Array<any>).map(AdminPlayerOfficialMatchToJSON)),
        'events': ((value['events'] as Array<any>).map(AdminPlayerParticipationEventToJSON)),
        'trainings': ((value['trainings'] as Array<any>).map(AdminPlayerTrainingAttendanceToJSON)),
    };
}

